/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum PendingExamCollectionAliases {
  BARCODE_INPUT_FIELD = 'barcode-input-field',
  DECK_PENDING_EXAM_COLLECTION = 'deck-pending-exam-collection',
  FETCH_PENDING_EXAM_COLLECTION = 'fetch-pending-exam-collection',
  FRAGMENT_INFORMATION_BAR_HEADER = 'fragment-information-bar-header ',
  GENERATE_TAG_DATA_ACTION = 'generate-tag-data-action',
  LAYOUT_BARCODE_CONTEXTAUL_BAR = 'layout-barcode-contextaul-bar',
  LAYOUT_LIST_EXAMS = 'layout-list-exams',
  MENU_PENDING_EXAM_COLLECTION_1 = 'menu-pending-exam-collection-1',
  PANEL_0 = 'panel-0',
  PANEL_4 = 'panel-4',
  PANEL_CONTAINER_INFORMATION_BAR_HEADER = 'panel-container-information-bar-header',
  PANEL_INFORMATION_BAR_HEADER = 'panel-information-bar-header',
  PANEL_LIST_EXAMS = 'panel-list-exams',
  PENDING_COLLECTION_EXAMS_CARD = 'pending-collection-exams-card',
  PENDING_EXAM_COLLECTION_CONTEXTUAL_BAR = 'pending-exam-collection-contextual-bar',
  PENDING_EXAM_COLLECTION_LAYOUT = 'pending-exam-collection-layout',
  TOAST_NOTIFICATION_SUCCESSFULLY = 'toast-notification-successfully',
  TOAST_SUCCESSFULLY_PANEL = 'toast-successfully-panel',
}
export { PendingExamCollectionAliases };
